import React from 'react';

import Layout from '../components/Layout';
import PageFooter from '../components/PageFooter';
import SideBar from '../components/SideBar';

import pic2 from '../assets/images/pic02.jpg';
import pic3 from '../assets/images/pic03.jpg';
import pic4 from '../assets/images/pic04.jpg';
import pic5 from '../assets/images/pic05.jpg';
import pic6 from '../assets/images/pic06.png';
import pic7 from '../assets/images/pic07.jpg';
import pic8 from '../assets/images/pic08.jpg';
import pic9 from '../assets/images/pic09.jpg';
import pic10 from '../assets/images/pic010.jpg';
import pic11 from '../assets/images/pic011.jpg';
import Scroll from '../components/Scroll';

const sections = [
  { id: 'top', name: 'Home', icon: 'fa-home' },
  { id: 'portfolio', name: 'Projects', icon: 'fa-th' },
  { id: 'about', name: 'About', icon: 'fa-user' },
  { id: 'contact', name: 'Contact', icon: 'fa-envelope' },
];

const IndexPage = () => (
  <Layout>
    <SideBar sections={sections} />

    <div id="main">
      <section id="top" className="one dark cover">
        <div className="container">
          <header>
            <h2 className="alt">
              Hi ! I'm <strong>Sambit                    </strong>
              <br />
              
              Java EE | Android App Developer
            </h2>
            <p>
              <br>
              </br>
              <br>
              </br>
            </p>
            <a href="./Sambit's Resume.pdf" className="button">
                Get CV
              </a>
             
      
          </header>

          <footer>
            <Scroll type="id" element={'portfolio'}>
              <a href="#portfolio" className="button">
                Explore
              </a>
            </Scroll>
         
          </footer>
        </div>
      </section>

      <section id="portfolio" className="two">
        <div className="container">
          <header>
            <h2>Projects</h2>
          </header>

          <p>
           
          </p>

          <div className="row">
            <div className="col-4 col-12-mobile">
            <article className="item">
                <a href="./Github-Profile-Viewer" className="image fit">
                  <img src={pic9} alt="" />
                </a>
                <header>
                  <h3>Github Profile Viewer [<a href="https://github.com/sambit77/WebApps-JS/tree/main/Github-Profile-Viewer"><font color = "blue">Source</font></a>]</h3>
                </header>
              </article>
              <article className="item">
                <a href="./Sketch-App" className="image fit">
                  <img src={pic5} alt="" />
                </a>
                <header>
                  <h3>Sketch App [<a href="https://github.com/sambit77/WebApps-JS/tree/main/Sketch-App"><font color = "blue">Source</font></a>]</h3>
                </header>
              </article>
              
             

              <article className="item">
                <a href="./Insane-Keypad.exe" className="image fit">
                  <img src={pic10} alt="" />
                </a>
                <header>
                  <h3>Insane Keypad [<a href="https://github.com/sambit77/Insane-Keypad"><font color = "blue">Source</font></a>]</h3>
                </header>
              </article>
            </div>
            <div className="col-4 col-12-mobile">
              <article className="item">
                <a href="./LPScanner.apk" className="image fit">
                  <img src={pic4} alt="" />
                </a>
                <header>
                  <h3>Number Plate Scanner [<a href="https://github.com/sambit77/Number-Plate-Scanner"><font color = "blue">Source</font></a>]</h3>
                 
                </header>
               
              </article>
              <article className="item">
                <a href="./Online-Examination-System" className="image fit">
                  <img src={pic2} alt="" />
                </a>
                <header>
                  <h3>Online Examination System [<a href="https://github.com/sambit77/Online-Examination-System"><font color = "blue">Source</font></a>]</h3>
                  
                </header>
              </article>
            </div>
            <div className="col-4 col-12-mobile">
              <article className="item">
                <a href="./NY-Countdown-Timer" className="image fit">
                  <img src={pic6} alt="" />
                </a>
                <header>
                  <h3>NY Countdown Timer [<a href="https://github.com/sambit77/WebApps-JS/tree/main/NY-Countdown-Timer"><font color = "blue">Source</font></a>]</h3>
                </header>
              </article>
              <article className="item">
                <a href="https://github.com/sambit77/Retailer-Project-JavaSE" className="image fit">
                  <img src={pic7} alt="" />
                </a>
                <header>
                  <h3>Retail Management [<a href="https://github.com/sambit77/Retailer-Project-JavaSE"><font color = "blue">Source</font></a>]</h3>
                </header>
              </article>
              <article className="item">
                <a href="./vlan.html" className="image fit">
                  <img src={pic11} alt="" />
                </a>
                <header>
                  <h3>Virtual LAN [<a href="https://github.com/sambit77/vlan-setup"><font color = "blue">Source</font></a>]</h3>
                </header>
              </article>
              
            </div>

            
          </div>
        </div>
      </section>

      <section id="about" className="three">
        <div className="container">
          <header>
            <h2>About</h2>
          </header>

          <a href="/#" className="image featured">
            <img src={pic8} alt="" />
          </a>

          <p>
          Sambit Pradhan is an articulate and passionate tech enthusiast with interests in Networking
          and Cybersecurity. He is skilled in Java EE Development and Android Application Development 
          with certifications from LIT-Bhubaneswar and Azure Skynet respectively. He has worked with 
          Bharat Sanchar Nigam Limited as an intern where he specialized in the domain of Networking,
          IP Address Allocation & Broadband Setup. He was also a member of the website penetration 
          testing & vulnerability assessment team at Odisha Skill Development Authority where he was 
          acknowledged for troubleshooting a critical bug in the organisation’s website which was making 
          it vulnerable to DOS attack.
          </p>
          <p>


          He is a go-getter, always in search of innovative solutions to complicated real-world problems.
         Dedication, hardwork and commitment are his core principal values. He is a person with strong 
         interpersonal skills and loves to get along with others. Going on trips and spending time with 
         friends are his favourite way to spend leisure time. 

          </p>
        </div>
      </section>

     

      <section id="contact" className="four">
        <div className="container">
          <header>
            <h2>Contact</h2>
          </header>

         

          <form method="post" action="mailto:sambitgulu@gmail.com">
            <div className="row">
              <div className="col-6 col-12-mobile">
                <input type="text" name="name" placeholder="Name" />
              </div>
              <div className="col-6 col-12-mobile">
                <input type="text" name="email" placeholder="Email" />
              </div>
              <div className="col-12">
                <textarea name="message" placeholder="Message" />
              </div>
              <div className="col-12">
                <input type="submit" value="Send Message" />
              </div>
            </div>
          </form>
        </div>
      </section>
    </div>

    <PageFooter />
  </Layout>
);

export default IndexPage;
